<template>
  <div :style="`background-color:${color}`" class="palette-chip">
    <v-row>
      <v-col cols="12" xs="10" md="10">
        <v-autocomplete
          v-if="isInType(type, [ModuleTypes.CHART, ModuleTypes.MULTICHART])"
          :label="color"
          autocomplete="off"
          :dark="false"
          :items="fieldNames"
          item-text="name"
          item-value="name"
          class="ps-2"
          v-model="fieldName"
          @change="constructMeta"
        ></v-autocomplete>
        <v-slider
          v-if="isInType(type, [ModuleTypes.GAUGE])"
          v-model="range"
          max="100"
          min="0"
          step="1"
          color="accent"
          :thumb-label="true"
          thumb-size="xs"
          :messages="color"
          @change="constructMeta"
        ></v-slider>
      </v-col>
      <v-col cols="12" xs="2" md="2" style="margin: 0; padding: 0">
        <v-icon
          color="accent"
          style="margin: 1rem auto"
          @click="$emit('remove')"
          >mdi-delete</v-icon
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModuleTypesMixin from "@/_helpers/ModuleTypeHelper.js";

export default {
  name: "PaletteChip",
  mixins: [ModuleTypesMixin],
  props: {
    type: {
      default: null,
    },

    metas: {
      type: Array,
    },

    color: {
      default: "#FFF",
    },

    meta: {
      default: {},
    },

    localMeta: {
      default: [],
    },

    fieldNames: {
      default: [],
    },
  },

  data() {
    return {
      range: 100,
      fieldName: "",
    };
  },

  async created() {
    this.getTags();
    if (this.meta.value) {
      this.fieldName = this.meta.value;
    }
  },

  computed: {
    ...mapState("tag", ["tags"]),
  },

  methods: {
    ...mapActions("tag", ["getTags"]),

    constructMeta() {
      if (this.isInType(this.type, [this.ModuleTypes.GAUGE])) {
        // range 0 has min range 1 has max
        this.$emit("update", {
          key: this.meta.key,
          content: this.color,
          valueMatch: this.range,
        });
      } else if (
        this.isInType(this.type, [
          this.ModuleTypes.CHART,
          this.ModuleTypes.MULTICHART,
        ])
      ) {
        this.$emit("update", {
          key: this.meta.key,
          content: this.color,
          value: this.fieldName,
        });
      }
    },
  },

  watch: {},
};
</script>

<style scoped>
.palette-chip {
  max-width: 230px;
  min-width: 230px;
  padding: 0.5rem;
  display: inline-block;
  border-radius: 0.5rem;
}
</style>